import { render } from "./VideoCallFrame.vue?vue&type=template&id=e3035740"
import script from "./VideoCallFrame.vue?vue&type=script&lang=ts"
export * from "./VideoCallFrame.vue?vue&type=script&lang=ts"
script.render = render

export default script